import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { isValidHttpUrl } from '../utils';
import { useUserExperienceConfig } from '../components/ConfigContext';
const useBeaconScript = (appTitle) => {
    const getUxConfig = useUserExperienceConfig();
    const [beaconUrl, setBeaconUrl] = useState(null);
    useEffect(() => {
        getUxConfig()
            .then((config) => {
            setBeaconUrl(config['RBAC_UI_BEACON_ANALYTICS_URL'] ?? '');
        })
            .catch(() => {
            // Beacon analytics won't load; non-critical
        });
    }, [getUxConfig]);
    useEffect(() => {
        if (beaconUrl === null)
            return; // config not yet fetched
        if (!beaconUrl || !isValidHttpUrl(beaconUrl)) {
            console.warn('Analytics tool is not configured.');
            return;
        }
        const title = appTitle || document.title;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.id = 'beaconScript';
        script.async = true;
        script.src = `${beaconUrl}/beacon.js`;
        script.dataset.log = 'false';
        script.dataset.apiRoot = beaconUrl;
        script.dataset.trackers = 'page,click,form';
        script.dataset.identity = 'userAndSession';
        script.dataset.metadata = JSON.stringify({ appTitle: title });
        script.onload = () => {
            if (globalThis.beacon) {
                const userObject = JSON.parse(Cookies.get('user') || '{}');
                let nameParts = [];
                if (userObject.userAttributes &&
                    typeof userObject.userAttributes.name === 'string') {
                    nameParts = userObject.userAttributes.name.split(/, | /);
                }
                globalThis.beacon.identify(userObject?.username || '', {
                    first_name: nameParts[1] || '',
                    last_name: nameParts[0] || '',
                    email: userObject.username || ''
                });
            }
        };
        document.head.appendChild(script);
        return () => {
            script.remove();
            delete globalThis.beacon;
        };
    }, [appTitle, beaconUrl]);
};
export default useBeaconScript;
